import { Tooltip } from "@mui/material";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faShip } from "@fortawesome/pro-solid-svg-icons";

export const ShipToShipPopover = ()  => {
	return (
		<>
			<Tooltip title="UNKNOWN_SHIP">
				<FontAwesomeIcon icon={faShip} style={{ color: "gray" }} />
			</Tooltip>
		</>
	);
};
